import { axiosClient } from '@/api/http/axios-client';
import type { AccountSummaryResponse } from '@shared/types';

async function getAccount(): Promise<AccountSummaryResponse> {
  const { data } = await axiosClient.get<AccountSummaryResponse>('/billing/account');
  return data;
}

export const BillingApi = {
  getAccount,
};
